import { useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export const MoveFolderDialog = ({ target, folders, onClose, onMoved }) => {
  const [sel, setSel] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (target) { setSel((target.client_name || "").trim() || "Unassigned"); setName(""); }
  }, [target]);

  const save = async () => {
    const dest = (sel === "__new__" ? name : sel).trim();
    if (!dest) return toast.error(sel === "__new__" ? "Enter the new folder name" : "Pick a folder");
    setBusy(true);
    try {
      await api.put(`/projects/${target.id}`, { name: target.name, client_name: dest === "Unassigned" ? "" : dest, folder_name: dest === "Unassigned" ? "" : dest });
      toast.success(`Moved "${target.name}" to ${dest}`);
      onClose();
      onMoved();
    } catch (e) { toast.error(apiError(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="move-folder-dialog">
        <DialogHeader><DialogTitle className="font-display">Move to folder - {target?.name}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label>Company / client folder</Label>
            <Select value={sel} onValueChange={setSel}>
              <SelectTrigger className="mt-1" data-testid="move-folder-select"><SelectValue placeholder="Pick a folder" /></SelectTrigger>
              <SelectContent>
                {folders.map((f) => <SelectItem key={f.name} value={f.name}>{f.name} ({f.items.length})</SelectItem>)}
                <SelectItem value="__new__">+ Create new folder…</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {sel === "__new__" && (
            <div>
              <Label>New folder name</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} className="mt-1"
                placeholder="e.g. Kingo Minerals Ltd" data-testid="move-folder-new" autoFocus />
            </div>
          )}
        </div>
        <DialogFooter>
          <Button onClick={save} disabled={busy} className="w-full" data-testid="move-folder-save">
            {busy ? "Moving…" : "Move project"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
